export function MiniShieldIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.21582 1.57727C4.58878 1.0179 5.41122 1.0179 5.78418 1.57727C6.37918 2.46978 7.58503 2.71134 8.47754 2.11633L8.82812 1.88196C9.11515 1.69061 9.49978 1.89645 9.5 2.24133V6.57727C9.5 7.56993 9.48804 7.90464 9.35156 8.1886C9.21507 8.4725 8.96152 8.69067 8.18652 9.31067L7.18652 10.1105C6.57779 10.5975 6.15533 10.9344 5.7998 11.1544C5.456 11.3671 5.22318 11.4386 5 11.4386C4.77682 11.4386 4.544 11.3671 4.2002 11.1544C3.84467 10.9344 3.42221 10.5975 2.81348 10.1105L1.81348 9.31067C1.03848 8.69067 0.784926 8.4725 0.648438 8.1886C0.511958 7.90464 0.5 7.56993 0.5 6.57727V2.24133C0.500217 1.89645 0.884853 1.69061 1.17188 1.88196L1.52246 2.11633C2.41497 2.71134 3.62082 2.46978 4.21582 1.57727Z"
        stroke="currentColor"
      />
    </svg>
  );
}
